import React from 'react'
import { useTranslation } from 'react-i18next';
import FormLogo from './FormLogo';

const FormHeader = ({language}) => {
  const { t } = useTranslation();

  return (
    <div className='header'>
      <FormLogo />
      {/* <div className='title'>
        {t('form.title')}
      </div> */}
      <div className='text'>
        {t('form.subtitle')}
      </div>
    </div>
  )
}

export default FormHeader;